module.exports = __webpack_public_path__ + "img/checkicon.d97258fe.svg";